/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CohortUpdateRequestState } from './cohortUpdateRequestState';
import type { CohortUpdateRequestIsDeprecated } from './cohortUpdateRequestIsDeprecated';

/**
 * to update a cohort
 */
export interface CohortUpdateRequest {
  title: string;
  state?: CohortUpdateRequestState;
  isDeprecated?: CohortUpdateRequestIsDeprecated;
}
